import { ComponentInternalInstance, getCurrentInstance, onUnmounted, onMounted } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { drawerHandler } from '@/renderer/scripts/composition/drawerHandler';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { SMH } from '@/renderer/scripts/smh';
export default function Handler() {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const store = vm.$store;
  // 抽屉相关的代码块
  const { drawerHandlerMethods } = drawerHandler();
  // 初始化的时候需要加载的是协作动态内容
  const workBenchDynamicScope: Drawer.WorkBenchDynamicScope = {
    title: i18n_t('协作动态'),
    componentName: 'Workbench',
  };
  onMounted(() => {
    drawerHandlerMethods.setDrawers([workBenchDynamicScope]);
  });

  // 当数据全部加载完毕
  const setTotal = (total: number) => {
    store.commit(DrawerEvents.SET_TOTAL, total);
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);

  // 数据改变时的代码块
  const selectChangedFun = (selectedList: SMH.RecentlyUsedFileItemData[]) => {
    if (selectedList.length === 0) {
      drawerHandlerMethods.setDrawers([workBenchDynamicScope]);
    }
    if (selectedList.length === 1) {
      if (!selectedList[0].visible) {
        tips.error(i18n_t('已被删除，请前往误删恢复找回'));
        return;
      }

      // 初始化的时候，立刻初始化详情组件
      const detailScope: Drawer.DetailScope<SMH.RecentlyUsedFileItemData> = {
        title: i18n_t('详细信息'),
        componentName: 'Detail',
        // 个人版本的spaceId会自动传递
        params: {
          selectedItem: selectedList[0],
          spaceId: selectedList[0]?.spaceId || '',
        },
      };
      const drawerArr = [detailScope];
      drawerHandlerMethods.setDrawers(drawerArr);
    }
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, selectChangedFun);
  // 事件卸载
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, selectChangedFun);
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, setTotal);
  });
  const setWorkbenchDefault = () => {
    drawerHandlerMethods.setDrawers([workBenchDynamicScope]);
  };
  return {
    methods: {
      setWorkbenchDefault,
    },
  };
}
